export default "__VITE_PUBLIC_ASSET__7bbc320f__"